import logo from './logo.svg';
import { BrowserRouter} from "react-router-dom";
import './App.css';
import Layout from './Layouts/Layout';
function App() {
  return (
    <BrowserRouter>
    <Layout/>
    </BrowserRouter>
  );
}

export default App;
